import React from "react";
import {toAbsoluteUrl} from "../../_helpers";

export function SplashScreen() {
  return (
    <>
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <div>
          <div className="w-300px">
            <img src={toAbsoluteUrl("/media/common/House.svg")} alt="logo"/>
          </div>
          <div className="w-100 mt-13 d-flex align-items-center justify-content-center">
            <img src={toAbsoluteUrl("/media/common/Spinner-apple_primary.svg")} alt="icon"/>
          </div>
        </div>
      </div>
    </>
  );
}
